import { handleError } from 'config/libraries';
import React, {Fragment, useState, useEffect} from 'react'
import { ServiceList } from '../components/pages-portal/service-list';
import 'styles/landing.css';
import { Header } from 'components/pages-portal/header';
import { Hero } from 'components/pages-portal/hero';
import { Sliders } from 'components/pages-portal/slider';
import { Footer } from 'components/pages-portal/footer';

export const Portal = () => {
    const [DataResponseLayanan, setDataResponseLayanan] = useState([]);
	const [DataResponseKonfig, setDataResponseKonfig] = useState([]);
    useEffect(() => {
      	const axios = require('axios');
        axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/informasi?slug_kategori_informasi=layanan').then(function (response) {
            setDataResponseLayanan(response.data.data.data);
        }).catch(function (error) {
            handleError(error)
        })

		axios.get(process.env.REACT_APP_SERVER_BASE_URL + '/konfigurasi-website').then(function (response) {
            setDataResponseKonfig(response.data.data[0]);
        }).catch(function (error) {
            handleError(error)
        })

        return () => {
            setDataResponseLayanan(null)
        };
    }, []);

    return (
        <Fragment>
            <div className="home-three dark-body">
            <div>
				<div className="page-wrapper">
					<div className="preloader" style={{display: 'none'}}></div>
					<Header />
					<Hero />
					<Sliders />

					<section className="solutions-section-three text-white text-center rel bg-blue pt-130 rpt-100 z-1 pb-75 rpb-45" style={{backgroundImage: 'url(assets/images/shapes/solutions-bg-dots.png)'}}>
						<div className="container">
							<div className="row justify-content-center">
							</div>
							{
								(DataResponseKonfig !== null) ?
								<div className="row justify-content-center text-center">
								<div className="col-lg-6 col-md-6">
									<div className="image mb-30 wow fadeInUp delay-0-2s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
										<img src={process.env.REACT_APP_SERVER_IMAGE_URL + DataResponseKonfig.foto_kepala} className='image-dinas' alt="Project" />
										<h4 className='mt-5 mb-2'>{DataResponseKonfig.nama_kepala}</h4>
										<span className='text-light-2'>Kepala Dinas Pendidikan dan Kebudayaan</span>
									</div>
								</div>
								<div className="col-lg-6 col-md-6">
									<div className="image mb-30 wow fadeInUp delay-0-4s" style={{visibility: 'visible', animationName: 'fadeInUp'}}>
										<img src={process.env.REACT_APP_SERVER_IMAGE_URL + DataResponseKonfig.foto_wakil_kepala} className='image-dinas' alt="Project" />
										<h4 className='mt-5 mb-2'>{DataResponseKonfig.nama_wakil_kepala}</h4>
										<span className='text-light-2'>Sekretaris Dinas Pendidikan dan Kebudayaan</span>
									</div>
								</div>
							</div> : ''
							}
							
						</div>
						</section>
					<section className="services-section-three bg-lighter rel z-1 pb-100 rpb-70">
						<div className="container">
							<div className="row justify-content-center text-center">
								<div className="col-xl-7 col-lg-8 col-md-10">
									<div className="section-title mt-100 rmt-70 mb-55">
										<span className="sub-title">Layanan Kami</span>
										<h2>Kami Memberikan Pelayanan Terbaik Pada Anda Dan Tanpa Biaya Apapun</h2>
									</div>
								</div>
							</div>
							<div className="row">
								{(DataResponseLayanan != null) ? <ServiceList response={DataResponseLayanan}/> : ''}
							</div>
						</div>
					</section>
				</div>
				<Footer />
				</div>
            </div>
        </Fragment>
    )
};

export default Portal;